export const DRAWER_WIDTH = 280;
export const COLLAPSE_WIDTH = 102;
export const APPBAR_MOBILE = 64;
export const APPBAR_DESKTOP = 92;
